import { render, staticRenderFns } from "./BulkClientHome.vue?vue&type=template&id=568c4f3a&scoped=true&"
import script from "./BulkClientHome.vue?vue&type=script&lang=js&"
export * from "./BulkClientHome.vue?vue&type=script&lang=js&"
import style0 from "./BulkClientHome.vue?vue&type=style&index=0&id=568c4f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568c4f3a",
  null
  
)

export default component.exports